import reducer from './reducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  language: reducer.setLanguage,
  breadcrumb: reducer.setBreadcrumb
});

export default rootReducer;
